<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { fly } from "svelte/transition";
    import { cn } from "~/utils";

    export let networkStatus: "idle" | "loading" = "idle";
    export let disabled: boolean | undefined = undefined;
    export let buttonStyle: "gradient-background" | "gradient-outline" =
        "gradient-background";

    const dispatch = createEventDispatcher();

    function handleClick() {
        dispatch("click");
    }
</script>

<button
    on:click={handleClick}
    {...$$restProps}
    class={cn(
        "flex h-16 w-full flex-col items-center justify-center rounded-full",
        buttonStyle === "gradient-background" &&
            "bg-gradient-to-br from-[var(--gradient-color1)] to-[var(--gradient-color2)] text-[var(--text-on-gradient-color)]",
        buttonStyle === "gradient-outline" &&
            "border-2 bg-[var(--primary-color)] text-[var(--text-on-primary-color)]",
        $$restProps.class,
    )}
    disabled={disabled ?? networkStatus === "loading"}
    data-style={buttonStyle}
>
    {#if networkStatus === "idle"}
        <div
            class={"w-full px-3 py-2 text-lg transition-transform hover:scale-105"}
            transition:fly={{ y: 24 }}
        >
            <slot name="title">Submit</slot>
        </div>
    {/if}
    {#if networkStatus === "loading"}
        <div
            class="flex flex-col items-center justify-center gap-4"
            transition:fly|local={{ y: 24 }}
        >
            <div class="p-4">
                <div
                    class="dot-typing"
                    style={cn(
                        buttonStyle === "gradient-background"
                            ? "--dots-color: var(--text-on-gradient-color);"
                            : "--dots-color: var(--text-on-primary-color);",
                    )}
                ></div>
            </div>
        </div>
    {/if}
</button>

<style>
    button {
        box-shadow: 0px 4px 4px 0px #00000040;
    }

    button[data-style="gradient-outline"] {
        border: 2px solid transparent;
        background-image: linear-gradient(white, white),
            linear-gradient(
                45deg,
                var(--gradient-color1) 8.9%,
                var(--gradient-color2) 94.17%
            );
        background-origin: border-box;
        background-clip: padding-box, border-box;
    }

    .dot-typing {
        position: relative;
        left: -9999px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: var(--dots-color);
        color: var(--dots-color);
        box-shadow:
            9984px 0 0 0 var(--dots-color),
            9999px 0 0 0 var(--dots-color),
            10014px 0 0 0 var(--dots-color);
        animation: dot-typing 1.5s infinite linear;
    }

    @keyframes dot-typing {
        0% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        16.667% {
            box-shadow:
                9984px -10px 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        33.333% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        50% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px -10px 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        66.667% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        83.333% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px -10px 0 0 var(--dots-color);
        }
        100% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
    }
</style>
